import { CollectionLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { CollectionPreviewTooltipFragment } from "@/components/collection/CollectionPreviewTooltip/CollectionPreviewTooltip.fragment"

export const GrandPrizeModalFragment = graphql(
  `
    fragment GrandPrizeModal on UserReward {
      id
      treasureChestId
      item {
        id
        name
        collection {
          ...CollectionLockup
          ...CollectionPreviewTooltip
          name
          imageUrl
        }
      }
    }
  `,
  [CollectionLockupFragment, CollectionPreviewTooltipFragment],
)
